/* eslint-disable react-hooks/exhaustive-deps */
import { MoreOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Dropdown, Input, message } from 'antd';
import Header from 'components/header';
import InviteUsersModal from 'components/inviteUsersModal';
import Sidebar from 'components/sidebar';
import UserTable from 'components/userTable';
import { useEffect, useState } from 'react';
import { addUser, listUsers } from 'services/api/workspace';
import styles from 'styles/users.module.scss';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [modalAddUserOpen, setModalAddUserOpen] = useState(false);
  const [addUserLoading, setAddUserLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [showDeactivated, setShowDeactivated] = useState(false);
  const [showUsersCountingAsSeat, setShowUsersCountingAsSeat] = useState(false);
  const fetchUsers = () => {
    return listUsers(showUsersCountingAsSeat)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((e) => {
        console.error(e);
        message.error(
          'Error while loading the users, please refresh the page.'
        );
      });
  };

  const inviteUsersFinish = (values) => {
    setAddUserLoading(true);
    return addUser(values)
      .then((res) => {
        fetchUsers();
        setModalAddUserOpen(false);
      })
      .catch((err) => {
        console.error('ERROR', err);
        if (err.response.data.error.code === 11000) {
          message.error(
            'User already exists in another workspace, try using an alias email.'
          );
        } else {
          message.error('Failed to Add users, please try again');
        }
      })
      .finally(() => {
        setAddUserLoading(false);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [showUsersCountingAsSeat]);

  useEffect(() => {
    fetchUsers();
  }, []);
  return (
    <div>
      <Header />
      <div className={styles.dashboardWrapper}>
        <Sidebar />
        <div className={styles.content}>
          <div className={styles.inner}>
            <div className={styles.header}>
              <div className={styles.headerContent}>
                <div className={styles.headerTitle}>
                  <h1>Users</h1>
                </div>
                <div className={styles.headerActions}>
                  <Button
                    icon={<PlusOutlined />}
                    type={'primary'}
                    onClick={() => {
                      setModalAddUserOpen(true);
                    }}
                  >
                    Invite new user
                  </Button>
                  <Dropdown
                    menu={{
                      onClick: (e) => {
                        if (e.key === 'showDeactivated') {
                          setShowDeactivated(true);
                        }
                        if (e.key === 'hideDeactivated') {
                          setShowDeactivated(false);
                        }
                      },
                      items: showDeactivated
                        ? [
                            {
                              key: 'hideDeactivated',
                              label: 'Hide deactivated users',
                            },
                          ]
                        : [
                            {
                              key: 'showDeactivated',
                              label: 'Show deactivated users',
                            },
                          ],
                    }}
                    trigger={['click']}
                  >
                    <Button type="link">
                      <MoreOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className={styles.usersList}>
              <div className={styles.searchInputWrapper}>
                <div className={styles.searchInput}>
                  <Input
                    placeholder="Search for a user"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    prefix={<SearchOutlined />}
                    style={{ width: '300px' }}
                    allowClear
                  />
                </div>

                <div>
                  <Checkbox
                    className={styles.checkbox}
                    checked={showUsersCountingAsSeat}
                    onChange={(e) => {
                      setShowUsersCountingAsSeat(e.target.checked);
                    }}
                  >
                    Show users counting as a seat
                  </Checkbox>
                </div>
              </div>
              <UserTable
                users={
                  showDeactivated
                    ? users
                    : users.filter((u) => !u.deactivatedAt)
                }
                filterSearch={search}
                showEditable={true}
                fetchUsers={fetchUsers}
              />
            </div>
          </div>
        </div>
      </div>
      <InviteUsersModal
        open={modalAddUserOpen}
        onCancel={() => setModalAddUserOpen(false)}
        onFinish={inviteUsersFinish}
        loading={addUserLoading}
      />
    </div>
  );
};

export default Users;
